import React from "react";
import NumberTransferOption from "./NumberTransferOption";
import styles from "./numberTransferTypes.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setNumberTranferType,
  setNumberTransferDetails,
} from "../../../Redux/actions/checkoutAction";
import { NumberTransferTypes as TransferTypes } from "../../../config/constants";
import * as Analytics from "../../../services/analyticsUtag";
import { FlagsContext } from "../../../pages/shopping/post-checkout";
import { NumberTransferCBU } from "../../organisms/NumberTransfer/NumberTransfer";

const NumberTransferTypes = ({customerStatus}) => {
  const dispatch = useDispatch();
  const selectTransferType = (type) => {
    dispatch(setNumberTranferType(type));
    dispatch(setNumberTransferDetails({}));
    sendAnalitycs(type);
  };
  const sendAnalitycs = (type) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `checkout number transfer: ${customerStatus}: ${type}`,
    });
  };
  const active = useSelector(
    ({ checkoutDetails }) => checkoutDetails.numberTransferType
  );
  return (
    <NumberTransferCBU.Consumer>
      {(content) => (
        <FlagsContext.Consumer>
          {({ vodacomPrepaidTransfer, otherPrepaidTransfer }) => (
            <>
              <p className={styles["number-transfer-step__subtitle"]}>
                {(content.sections || 0)[0]?.headingTitle}
              </p>
              <div className={styles["number-transfer-types__wrapper"]}>
                <NumberTransferOption
                  icon="new-number"
                  title={((content.sections || 0)[0]?.items || [])[0]?.title}
                  selected={active === TransferTypes.NEW_NUMBER}
                  onClick={() => selectTransferType(TransferTypes.NEW_NUMBER)}
                />
                {vodacomPrepaidTransfer && (
                  <NumberTransferOption
                    icon="vod-gray"
                    title={((content.sections || 0)[0]?.items || [])[1]?.title}
                    selected={active === TransferTypes.VOD_NUMBER}
                    onClick={() => selectTransferType(TransferTypes.VOD_NUMBER)}
                  />
                )}
                {otherPrepaidTransfer && (
                  <NumberTransferOption
                    icon="external-number"
                    title={((content.sections || 0)[0]?.items || [])[2]?.title}
                    selected={active === TransferTypes.EXTERNAL}
                    onClick={() => selectTransferType(TransferTypes.EXTERNAL)}
                  />
                )}
              </div>
            </>
          )}
        </FlagsContext.Consumer>
      )}
    </NumberTransferCBU.Consumer>
  );
};

export default NumberTransferTypes;
